import constants from '@/app-configs/constants'

export default [
  {
    path: '/clients/list',
    name: 'clients-list',
    component: () => import('@/views/client/clients-list/ClientsList.vue'),
    meta: {
      pageTitle: 'DEBTIA_CLIENTS',
      breadcrumb: [
        {
          text: 'DEBTIA_CLIENTS',
          active: true,
        },
      ],
      action: constants.action.permissionClientView,
      resource: constants.resource.client,
      companyOnly: true,
    },
  },
  {
    path: '/users/view/:id',
    name: 'users-view',
    component: () => import('@/views/user/users-view/UsersView.vue'),
    meta: {
      action: constants.action.permissionClientView,
      resource: constants.resource.client,
      companyOnly: true,
    },
  },
  {
    path: '/clients/edit/:id',
    name: 'client-edit',
    component: () => import('@/views/client/client-edit/ClientEdit.vue'),
    meta: {
      action: constants.action.permissionClientEdit,
      resource: constants.resource.client,
      companyOnly: true,
    },
  },
  {
    path: '/clients/view/:id',
    name: 'client-view',
    component: () => import('@/views/client/client-view/ClientsView.vue'),
    meta: {
      action: constants.action.permissionClientEdit,
      resource: constants.resource.client,
      companyOnly: true,
    },
  },
  {
    path: '/clients/view-invoice/:id',
    name: 'client-view-invoice',
    component: () => import('@/views/client/client-view/InvoiceDetails.vue'),
    meta: {
      action: constants.action.permissionClientView,
      resource: constants.resource.client,
      companyOnly: true,
    },
  },
  {
    path: '/clients/add',
    name: 'clients-add',
    component: () => import('@/views/client/clients-add/ClientsAdd.vue'),
    meta: {
      title: 'add users',
      action: constants.action.permissionClientAdd,
      resource: constants.resource.client,
      companyOnly: true,
    },
  },
]
